import React from 'react'
import './Home.css'
import Hero from './Hero'
import WhoAreWe from './WhoAreWe'
import WhatWeOffer from './WhatWeOffer'
import Empowering from './Empowering'
import Card from './Card'

function Home() {
  return (
    <>
    <Hero/>
    <WhoAreWe/>
    <WhatWeOffer/>
    <Empowering/>
    <Card/>
    </>
  )
}

export default Home
